import { render, staticRenderFns } from "./TPopover.vue?vue&type=template&id=64cf50f3&scoped=true&"
import script from "./TPopover.vue?vue&type=script&lang=js&"
export * from "./TPopover.vue?vue&type=script&lang=js&"
import style0 from "./TPopover.vue?vue&type=style&index=0&id=64cf50f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cf50f3",
  null
  
)

/* custom blocks */
import block0 from "./TPopover.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports